import React from 'react'
import { useDispatch, useSelector } from 'react-redux'
import {
  selectProperty,
  setProperty,
} from '../../../../features/State Management/questionSlice'
import { FilledInput, FormControl, InputLabel } from '@material-ui/core'
import useLocale from '../../../../customHooks/useLocale'
import {
  getLocalizedValue,
  setLocalizedValue,
} from '../../../../utils/localeUtils'

export const TextProperty = ({
  name,
  propertyName,
  required = false,
  ...props
}) => {
  const locale = useLocale()
  const rawProperty = useSelector(selectProperty(propertyName))
  const property = getLocalizedValue(rawProperty, locale)
  const dispatch = useDispatch()

  const handleChange = (event) => {
    dispatch(
      setProperty({
        property: propertyName,
        value:
          propertyName === 'image'
            ? event.target.value
            : setLocalizedValue(rawProperty, event.target.value, locale),
      })
    )
  }

  return (
    <FormControl fullWidth required={required}>
      <InputLabel variant='filled' style={{ userSelect: 'none' }}>
        {name}
      </InputLabel>
      <FilledInput
        data-cy={propertyName + property}
        autoComplete='off'
        type='text'
        id={propertyName}
        placeholder={name}
        value={property}
        onChange={handleChange}
        {...props}
      />
    </FormControl>
  )
}
